export default __webpack_public_path__ + "static/media/logotonatrilha.6fcff7f7.png";